module.exports = __webpack_public_path__ + "img/5.fd33b99a.jpg";